import '../styles/common.css'

import { Transition } from '@headlessui/react'
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Banner from '../../pages/Home/Banner'
import { isEarlyBird } from '../../utils'

export default function NavbarHome() {
  const location = useLocation()
  useEffect(() => {
    const handleClose = () => {
      setIsOpen(false)
    }
    window.addEventListener('click', handleClose)
    return () => {
      window.removeEventListener('click', handleClose)
    }
  }, [])
  const isCurrentURL = (url) => {
    return location.pathname.toLowerCase() === url.toLowerCase()
  }

  const classNames = (...classes) => {
    return classes.filter(Boolean).join(' ')
  }

  const isUserLogin = localStorage.getItem('swToken')
  const [isOpen, setIsOpen] = useState(false)

  // Sticky Menu Area

  return (
    <>
      {/* <div className="loginNav absolute 2xl:w-9/12 xl:w-9/12 lg:w-10/12 md:w-10/12 w-screen h-screen"></div> */}

      <nav
        style={{ fontFamily: 'Noto Sans' }}
        className='bg-themeColor md:bg-themeColor fixed w-full top-0 z-50'
      >
        <Banner />

        <div className='max-w-screen-xl mx-auto px-6 sm:px-6 lg:px-8'>
          <div className='flex items-center justify-between h-16'>
            <div>
              <Link
                to='/'
                className='flex title-font font-large items-center justify-start text-white'
              >
                <img
                  src='/images/logo.png'
                  className='w-48 h-15 p-1'
                  alt='Scopex logo'
                />
              </Link>
            </div>
            <div className='hidden md:block font-nunito md:basis-3/4'>
              <div className='flex justify-end'>
                <div className='flex  items-right'>
                  <ul className='flex text-white items-center gap-6 text-lg lg:text-xl'>
                    <li className=''>
                      <Link
                        to='/Login'
                        className=' font-bold rounded items-center'
                      >
                        Send money
                      </Link>
                    </li>
                    <li className=''>
                      <Link
                        to='/Faqs'
                        className='  font-bold rounded items-center'
                      >
                        FAQs
                      </Link>
                    </li>
                    <li className=''>
                      <Link
                        to='/Contact'
                        className='  font-bold rounded items-center'
                      >
                        Contact us
                      </Link>
                    </li>

                    {!isUserLogin && (
                      <div>
                        {isEarlyBird ? (
                          <></>
                        ) : (
                          <li className=''>
                            <Link
                              to='/Login'
                              className='relative px-2 md:px-3  lg:px-4  font-bold rounded items-center'
                            >
                              Login
                            </Link>
                          </li>
                        )}
                      </div>
                    )}
                    <li>
                      {isEarlyBird ? (
                        <Link
                          className='relative xl:block bg-white lg:block md:block hidden text-themeColor py-1 px-2 w-32 lg:p-2 font-bold rounded-xl text-center hover:bg-themeColor hover:text-white'
                          to={'/EarlyBird'}
                          data-test='know-more-lg'
                        >
                          Know more
                        </Link>
                      ) : (
                        <Link
                          to={isUserLogin ? '/Dashboard' : '/SignUp'}
                          className='relative xl:block bg-white lg:block md:block hidden text-themeColor py-1 px-2 w-32 lg:p-2 font-bold rounded-xl text-center hover:bg-themeColor hover:text-white'
                        >
                          {isUserLogin ? 'Dashboard' : 'Register'}
                        </Link>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='flex md:hidden font-nunito justify-end basis-3/4'>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  setIsOpen(!isOpen)
                }}
                type='button'
                className='inline-flex items-center justify-end p-2 rounded-md text-gray-400 hover:text-sky-800 hover:bg-themeHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-sky-800 focus:ring-white'
                aria-controls='mobile-menu'
                aria-expanded='false'
                style={{ backgroundColor: '#ffffff' }}
              >
                <span className='sr-only'>Open main menu</span>
                {!isOpen ? (
                  <svg
                    className='block h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M4 6h16M4 12h16M4 18h16'
                    />
                  </svg>
                ) : (
                  <svg
                    className='block h-6 w-6'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    aria-hidden='true'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M6 18L18 6M6 6l12 12'
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <Transition
          show={isOpen}
          enter='transition ease-out duration-100 transform'
          enterFrom='opacity-0 scale-95'
          enterTo='opacity-100 scale-100'
          leave='transition ease-in duration-75 transform'
          leaveFrom='opacity-100 scale-100'
          leaveTo='opacity-0 scale-95'
        >
          {(ref) => (
            <div className='md:hidden font-nunito text-center' id='mobile-menu'>
              <div
                ref={ref}
                className='px-2 pt-2 pb-3 space-y-1 sm:px-3'
                style={{ backgroundColor: '#246eaa' }}
              >
                <ul className=' text-white'>
                  <li className=''>
                    <Link to={isEarlyBird ? '/EarlyBird' : '/Login'}>
                      <button className='relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center'>
                        Send money
                      </button>
                    </Link>
                  </li>
                  {/* <li className="">
                    <Link to="/Track">
                      <button className="relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center">
                        Track transfer
                      </button>
                    </Link>
                  </li> */}
                  <li className=''>
                    <Link to='/Faqs'>
                      <button className='relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center'>
                        FAQs
                      </button>
                    </Link>
                  </li>
                  <li className=''>
                    <Link to='/Contact'>
                      <button className='relative py-3 px-2 md:px-3 lg:px-4 text-lg lg:text-base font-bold rounded items-center'>
                        Contact us
                      </button>
                    </Link>
                  </li>

                  <li>
                    <div className='xl:mt-4 lg:mt-4 md:mt-5 mr-4'>
                      {isEarlyBird ? (
                        <Link to={'/EarlyBird'}>
                          <button
                            type='button'
                            style={{ backgroundColor: 'white' }}
                            data-test='know-more'
                            className='relative text-black py-3 px-2 w-56 md:px-3 lg:px-4 text-md lg:text-base font-bold rounded-xl items-center'
                          >
                            Know more
                          </button>
                        </Link>
                      ) : (
                        <Link to={isUserLogin ? '/Dashboard' : '/Login'}>
                          <button
                            type='button'
                            style={{ backgroundColor: 'white' }}
                            className='relative text-black py-3 px-2 w-56 md:px-3 lg:px-4 text-md lg:text-base font-bold rounded-xl items-center'
                          >
                            {isUserLogin ? 'Dashboard' : 'Login'}
                          </button>
                        </Link>
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </Transition>
      </nav>
    </>
  )
}
